var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67994 1.43994C4.23834 1.43994 1.43994 4.23834 1.43994 7.67994V16.3199C1.43994 19.7615 4.23834 22.5599 7.67994 22.5599H16.3199C19.7615 22.5599 22.5599 19.7615 22.5599 16.3199V7.67994C22.5599 4.23834 19.7615 1.43994 16.3199 1.43994H7.67994ZM17.7599 5.27994C18.2879 5.27994 18.7199 5.71194 18.7199 6.23994C18.7199 6.76794 18.2879 7.19994 17.7599 7.19994C17.2319 7.19994 16.7999 6.76794 16.7999 6.23994C16.7999 5.71194 17.2319 5.27994 17.7599 5.27994ZM11.9999 6.71994C14.9135 6.71994 17.2799 9.08634 17.2799 11.9999C17.2799 14.9135 14.9135 17.2799 11.9999 17.2799C9.08634 17.2799 6.71994 14.9135 6.71994 11.9999C6.71994 9.08634 9.08634 6.71994 11.9999 6.71994ZM11.9999 7.67994C9.61914 7.67994 7.67994 9.61914 7.67994 11.9999C7.67994 14.3807 9.61914 16.3199 11.9999 16.3199C14.3807 16.3199 16.3199 14.3807 16.3199 11.9999C16.3199 9.61914 14.3807 7.67994 11.9999 7.67994Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.4a0012c0.svg";
export { ForwardRef as ReactComponent };